import React from 'react'
import { withTranslation } from 'react-i18next'

import PersonalityQuizModal from './Modals/PersonalityQuizModal/PersonalityQuizModal.jsx'
import EditBlockButton from './Controls/EditBlockButton'
import StartScreen from './Components/StartScreen/StartScreen'
import NoCover from './Components/NoCover/NoCover'
import './PersonalityQuiz.scss'

class PersonalityQuiz extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
        }
    }

    openModal = evt => {
        evt.preventDefault()
        this.setState({
            showModal: true,
        })
    }
    closeModal = () => {
        this.setState({
            showModal: false,
        })
    }

    render() {
        const {
            blockData: { struct, colorTheme, id },
            pagesData,
            onUpdate,
        } = this.props
        const { showModal } = this.state

        return (
            <div className={`block personality-quiz`}>
                <EditBlockButton onClick={this.openModal} />

                {Object.keys(struct).length && struct.cover.isShowCover ? (
                    <StartScreen struct={struct} backgroundColor={colorTheme} />
                ) : (
                    <NoCover />
                )}

                {showModal ? (
                    <PersonalityQuizModal
                        data={{
                            pages: pagesData,
                            structure: struct,
                            colorTheme: colorTheme,
                            id,
                        }}
                        methods={{
                            closeModal: this.closeModal,
                            save: onUpdate,
                        }}
                    />
                ) : null}
            </div>
        )
    }
}

export default withTranslation('translations')(PersonalityQuiz)
